import { render, staticRenderFns } from "./AoAgencyDataTable.vue?vue&type=template&id=0add0961&"
import script from "./AoAgencyDataTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AoAgencyDataTable.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports